if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				if ( this.productGallery.dataset.jsDisableParallax == 'false' ) {
					this.productSlider.addEventListener('ready', (e)=>{
						
						if ( this.firstProductGalleryIndex ) {
							this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
						}

						const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
						const productFigures = this.querySelectorAll('.apply-gallery-animation');
						this.productSlider.addEventListener('scroll', ()=>{
							const scrollX = -this.productSlider.element.scrollLeft;
							productSlides.forEach((slide,i)=>{
								const media = productFigures[i];
								if ( media ) {
									media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
								}
							});
						});

					});
				}

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}
		}
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}

/* ---
	Combined Listing — default to the first available size on the parent landing

	A Shopify "combined listing" PARENT product merges every child product's media into
	one gallery, so the parent page shows ALL sizes' images at once (confusing). Each
	child product page already renders only its own media / price / add-to-cart, and the
	theme navigates to the matching child whenever a size (or other option) is chosen —
	so the ONLY confusing state is the initial parent landing.

	Fix: when we detect a merged parent, fetch the first AVAILABLE size's child section
	and swap the whole main-product section into place, keeping the parent URL. The
	gallery, price and add-to-cart then all reflect that one size. Specific child pages
	(including a size the shopper deliberately picked) and ordinary products are left
	untouched.

	Detection: a combined-listing option value carries data-product-url pointing at a
	child product. If one of those urls equals the section's own data-url, we are already
	on a specific child → do nothing. If NONE match, we are on the merged parent → swap.
--- */
if ( ! window.__combinedListingDefaultSize ) {
	window.__combinedListingDefaultSize = true;

	const __cl_samePath = ( a, b ) => {
		if ( ! a || ! b ) return false;
		try {
			const pa = new URL(a, window.location.origin).pathname.replace(/\/+$/, '');
			const pb = new URL(b, window.location.origin).pathname.replace(/\/+$/, '');
			return pa === pb;
		} catch ( e ) { return false; }
	};

	const __cl_resolveDefaultSize = () => {

		// Don't interfere with the theme editor.
		if ( window.Shopify && window.Shopify.designMode ) return;

		const pv = document.querySelector('product-variants[data-main-product-page-variants]');
		if ( ! pv ) return;

		const currentUrl = pv.dataset.url;
		const sectionId = pv.dataset.helperId;
		if ( ! currentUrl || ! sectionId ) return;

		// Option values that link to a combined-listing child product.
		const linked = pv.querySelectorAll('[data-option-value-id][data-product-url]');
		if ( ! linked.length ) return; // not a combined listing → leave ordinary products alone

		// If any linked value points at the product we're already on, this is a specific
		// child page (incl. one the shopper deliberately navigated to) → leave it as-is.
		for ( const v of linked ) {
			if ( __cl_samePath(v.dataset.productUrl, currentUrl) ) return;
		}

		// Merged parent → first AVAILABLE value of the first option (size), falling back
		// to the first linked value.
		const firstOption = pv.querySelector('[data-js-product-variant]') || pv;
		const values = firstOption.querySelectorAll('[data-option-value-id][data-product-url]');
		let target = null;
		for ( const v of values ) { if ( v.dataset.available === 'true' ) { target = v; break; } }
		if ( ! target ) target = values[0];
		if ( ! target ) return;

		const targetUrl = target.dataset.productUrl;
		if ( ! targetUrl || __cl_samePath(targetUrl, currentUrl) ) return;

		const oldSection = document.getElementById('shopify-section-' + sectionId);
		if ( ! oldSection ) return;

		// Avoid a flash of the merged gallery while we fetch.
		const gallery = oldSection.querySelector('[data-js-product-gallery]');
		if ( gallery ) gallery.style.visibility = 'hidden';

		fetch(`${targetUrl}${targetUrl.includes('?') ? '&' : '?'}section_id=${sectionId}`)
			.then(r => r.text())
			.then(text => {
				const doc = new DOMParser().parseFromString(text, 'text/html');
				const fresh = doc.getElementById('shopify-section-' + sectionId) || doc.querySelector('.shopify-section');
				if ( ! fresh ) throw new Error('combined-listing: section not found in response');
				// The sticky add-to-cart lives on <body> and references the old product-page;
				// remove it so the fresh section can mount a new one bound to the new page.
				document.querySelectorAll('sticky-add-to-cart').forEach(el => el.remove());
				oldSection.replaceWith(fresh); // custom elements re-upgrade → full re-init
				if ( typeof window.initPdpEnhancements === 'function' ) {
					window.initPdpEnhancements(fresh);
				}
			})
			.catch(() => { if ( gallery ) gallery.style.visibility = ''; });
	};

	if ( document.readyState === 'loading' ) {
		document.addEventListener('DOMContentLoaded', __cl_resolveDefaultSize);
	} else {
		__cl_resolveDefaultSize();
	}
}